// extracted by mini-css-extract-plugin
module.exports = {"content_container":"AddCasePopup_content_container__1Eril","error_container":"AddCasePopup_error_container__1KlYV","error_text":"AddCasePopup_error_text__19r2b"};